
import _ from 'underscore'
import d3 from 'd3'
import Backbone from 'backbone'

const mouseEvents = [
  'click',
  'contextmenu',
  'dblclick',
  'mousedown',
  'mouseenter',
  'mouseleave',
  'mousemove',
  'mouseout',
  'mouseover',
  'mouseup',
  'show',
];

class HitAreaView extends Backbone.View {

  initialize() {
    this.d3el = d3.select(this.el)
    this.bindEvents()
  }

  bindEvents() {
    this.handleEvent = this.handleEvent.bind(this)

    this.listenTo(this.model, 'change:fill change:stroke change:strokeWidth', this.renderAttributes)
  }

  unbindEvents() {
    this.stopListening()
  }

  handleEvent() {
    let map = this.model.mapModel()

    // TODO: Investigate future support for events on individual models.
    // this.model.trigger(`${d3.event.type}`, {hitarea: this.model})

    map.dispatcher.trigger(`hitarea:${d3.event.type}`, {
      hitarea: this.model.facade(),
      originalEvent: d3.event
    })
  }

  renderAttributes() {
    let {d3el, model} = this
    
    let fill = model.get('fill')
    let stroke = model.get('stroke')
    let strokeWidth = model.get('strokeWidth')

    d3el.attr('fill', fill)
    d3el.attr('stroke', stroke)
    d3el.attr('stroke-width', strokeWidth)
  }

  render() {
    let {d3el, model} = this

    let attributes = _.omit(model.get('shape'), 'type')
    attributes.fill = model.get('fill')
    attributes.stroke = model.get('stroke')
    attributes['stroke-width'] = model.get('strokeWidth')

    // Bind mouse events.
    
    _.each(mouseEvents, (event) => d3el.on(event, this.handleEvent))

    _.each(attributes, function (value, name) {
      d3el.attr(name, value)
    })

    return this
  }
}

export default HitAreaView
